/* unplugin-vue-components disabled */import { render } from "./FooterMusci.vue?vue&type=template&id=1980638c&scoped=true"
import script from "./FooterMusci.vue?vue&type=script&lang=js"
export * from "./FooterMusci.vue?vue&type=script&lang=js"

import "./FooterMusci.vue?vue&type=style&index=0&id=1980638c&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1980638c"]])

export default __exports__